// AudioQuest PowerQuest landing page
// Product data is injected server-side by sections/audioquest-powerquest-landing.liquid
// as window.aqPowerquestProducts (built from real Shopify products/prices, not hardcoded).
(function () {
    function initAqPq(root) {
        if (!root || root.dataset.aqPqInit === 'true') return;
        root.dataset.aqPqInit = 'true';

        var products = window.aqPowerquestProducts || [];

        var productsGrid = root.querySelector('[data-aq-products-grid]');
        var tierBtns = root.querySelectorAll('[data-aq-tier-btn]');
        var faqQuestions = root.querySelectorAll('[data-aq-faq-question]');
        var modal = root.querySelector('[data-aq-modal]');
        var modalClose = root.querySelector('[data-aq-modal-close]');
        var modalHeader = root.querySelector('[data-aq-modal-header]');
        var modalBody = root.querySelector('[data-aq-modal-body]');

        var finderGroups = root.querySelectorAll('[data-aq-finder-group]');
        var finderSubmit = root.querySelector('[data-aq-finder-submit]');
        var finderResult = root.querySelector('[data-aq-finder-result]');
        var finderResultName = root.querySelector('[data-aq-finder-result-name]');
        var finderResultReason = root.querySelector('[data-aq-finder-result-reason]');
        var finderResultPrice = root.querySelector('[data-aq-finder-result-price]');
        var finderResultLink = root.querySelector('[data-aq-finder-result-link]');
        var finderAnswers = {};

        function money(value) {
            var num = parseFloat(value);
            if (isNaN(num)) return '—';
            return '$' + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        function findProduct(id) {
            return products.filter(function (p) { return p.id === id; })[0];
        }

        function findByFinderRole(role) {
            return products.filter(function (p) { return p.finderRole === role; })[0] || null;
        }

        function priceLabel(product) {
            if (product.comingSoon) return product.comingSoonLabel || 'Coming Soon';
            if (product.price !== null && product.price !== undefined) return money(product.price);
            return '—';
        }

        function badgeClass(style) {
            if (style === 'gold' || style === 'red' || style === 'green' || style === 'new' || style === 'muted') return 'aq-badge-' + style;
            return '';
        }

        // =====================================================
        // PRODUCT GRID
        // =====================================================
        function renderProducts(tier) {
            if (!productsGrid) return;
            var filtered = products.filter(function (p) { return p.tier === tier; });

            productsGrid.innerHTML = filtered.map(function (product) {
                var badgeCls = badgeClass(product.badgeStyle);
                var cardCls = 'aq-product-card' + (badgeCls ? ' ' + badgeCls : '');
                var imageHtml = product.image
                    ? '<img src="' + product.image + '" alt="AudioQuest ' + product.name + '" loading="lazy">'
                    : '';

                var features = (product.features || []).filter(Boolean).slice(0, 4).map(function (f) {
                    return '<li>' + f + '</li>';
                }).join('');

                var cablesHtml = '';
                if (product.cableBestName) {
                    cablesHtml =
                        '<div class="aq-cable-recs">' +
                            '<span class="aq-cable-recs-label">Recommended Power Cables</span>' +
                            '<div class="aq-cable-recs-options">' +
                                '<a href="' + (product.cableBestUrl || '#') + '" target="_blank" rel="noopener" class="aq-cable-rec-link best">Best: ' + product.cableBestName + '</a>' +
                                (product.cableBetterName ? '<a href="' + (product.cableBetterUrl || '#') + '" target="_blank" rel="noopener" class="aq-cable-rec-link">Better: ' + product.cableBetterName + '</a>' : '') +
                            '</div>' +
                        '</div>';
                }

                var viewBtn = product.url
                    ? '<a href="' + product.url + '" class="aq-btn aq-btn-primary">View Product</a>'
                    : '';

                return (
                    '<div class="' + cardCls + '" data-product="' + product.id + '">' +
                        (product.badgeLabel ? '<span class="aq-product-badge ' + badgeCls + '">' + product.badgeLabel + '</span>' : '') +
                        '<div class="aq-product-image' + (imageHtml ? '' : ' no-image') + '">' + imageHtml + '</div>' +
                        '<div class="aq-product-content">' +
                            '<h3 class="aq-product-name">' + product.name + '</h3>' +
                            (product.tagline ? '<p class="aq-product-tagline">' + product.tagline + '</p>' : '') +
                            '<ul class="aq-product-features">' + features + '</ul>' +
                            cablesHtml +
                            '<div class="aq-product-price"><span class="aq-price-value">' + priceLabel(product) + '</span></div>' +
                            '<div class="aq-product-cta">' +
                                '<button type="button" class="aq-btn aq-btn-secondary" data-aq-show-details="' + product.id + '">Learn More</button>' +
                                viewBtn +
                            '</div>' +
                        '</div>' +
                    '</div>'
                );
            }).join('');
        }

        // =====================================================
        // PRODUCT DETAIL MODAL
        // =====================================================
        function showProductDetails(productId) {
            var product = findProduct(productId);
            if (!product || !modal) return;

            if (modalHeader) {
                modalHeader.innerHTML =
                    '<h2 style="font-size: 1.6rem; margin-bottom: 0.5rem;">' + product.name + '</h2>' +
                    (product.tagline ? '<p style="color: var(--aq-text-secondary);">' + product.tagline + '</p>' : '');
            }

            if (modalBody) {
                var featuresHtml = (product.features || []).filter(Boolean).map(function (f) {
                    return '<li><span>✓</span> ' + f + '</li>';
                }).join('');

                var cablesHtml = '';
                if (product.cableBestName) {
                    cablesHtml =
                        '<div class="aq-modal-cables">' +
                            '<h4>Power Cable Required (Sold Separately)</h4>' +
                            '<div class="aq-modal-cable-options">' +
                                '<a href="' + (product.cableBestUrl || '#') + '" target="_blank" rel="noopener" class="aq-modal-cable-link best">Best: ' + product.cableBestName + '</a>' +
                                (product.cableBetterName ? '<a href="' + (product.cableBetterUrl || '#') + '" target="_blank" rel="noopener" class="aq-modal-cable-link">Better: ' + product.cableBetterName + '</a>' : '') +
                            '</div>' +
                        '</div>';
                }

                var idealHtml = product.idealFor
                    ? '<div class="aq-modal-ideal"><h4>Ideal For</h4><p>' + product.idealFor + '</p></div>'
                    : '';

                var viewBtn = product.url
                    ? '<a href="' + product.url + '" class="aq-btn aq-btn-primary">View Product</a>'
                    : '<span class="aq-btn aq-btn-primary is-disabled">Not Yet Available</span>';

                modalBody.innerHTML =
                    '<div><h4>Features &amp; Specifications</h4><ul class="aq-modal-feature-list">' + featuresHtml + '</ul></div>' +
                    cablesHtml +
                    idealHtml +
                    '<div class="aq-modal-footer">' +
                        '<span class="aq-modal-price">' + priceLabel(product) + '</span>' +
                        viewBtn +
                    '</div>';
            }

            modal.classList.add('active');
        }

        // =====================================================
        // SYSTEM FINDER
        // =====================================================
        var roleDescriptions = {
            g8: function () { return 'Affordable power strip with USB-A and USB-C charging ports. Perfect for desks and gaming setups.'; },
            tv3: function () { return 'Ultra-compact wall-mount design perfect for behind your TV with protected outlets.'; },
            compact_low: function () { return 'Slim profile perfect for behind furniture.'; },
            compact_high: function () { return 'Versatile design with a removable stand for flexible placement.'; },
            full_low: function (reasons) { return 'Essential protection for your ' + (reasons[0] || 'system') + ' with linear noise filtering.'; },
            full_mid: function (reasons) { return 'Advanced performance for your ' + reasons.join(', ') + '. Includes both differential and common-mode filtering.'; },
            full_high: function (reasons) { return 'Ultimate protection and performance for your ' + reasons.join(', ') + '. Features 45-amp transient power correction.'; },
            full_top: function (reasons) { return 'The absolute best for your ' + reasons.join(', ') + '. Hospital-grade outlets, a 20-amp circuit, and 45-amp transient power correction for the most demanding reference systems.'; }
        };

        function calculateRecommendation(answers) {
            var score = 0;
            var reasons = [];

            switch (answers.systemType) {
                case 'desktop': score += 1; reasons.push('desktop/headphone setup'); break;
                case 'stereo': score += 2; reasons.push('2-channel stereo system'); break;
                case 'home-theater': score += 3; reasons.push('home theater system'); break;
            }

            switch (answers.highPower) {
                case '1-2': score += 1; break;
                case '3-4': score += 2; break;
                case '5+': score += 3; reasons.push('multiple high-power components'); break;
            }

            switch (answers.priority) {
                case 'protection': score += 1; reasons.push('protection-focused'); break;
                case 'performance': score += 2; reasons.push('performance-focused'); break;
                case 'both': score += 3; reasons.push('balanced protection and performance'); break;
            }

            var useCompact = answers.space === 'behind' && score < 5;
            var useTV3 = answers.systemType === 'desktop' && answers.highPower === '1-2' && answers.space === 'behind';
            var useG8 = answers.systemType === 'desktop' && answers.highPower === '1-2' && answers.priority === 'protection' && answers.space === 'floor';

            var role;
            if (useG8) role = 'g8';
            else if (useTV3) role = 'tv3';
            else if (useCompact) role = answers.highPower === '1-2' ? 'compact_low' : 'compact_high';
            else if (score <= 4) role = 'full_low';
            else if (score <= 6) role = 'full_mid';
            else if (score <= 8) role = 'full_high';
            else role = 'full_top';

            var product = findByFinderRole(role);
            var description = roleDescriptions[role] ? roleDescriptions[role](reasons) : '';

            return { product: product, description: description };
        }

        function displayRecommendation(result) {
            if (!finderResult) return;

            if (!result.product) {
                if (finderResultName) finderResultName.textContent = 'Add products in the theme editor';
                if (finderResultReason) finderResultReason.textContent = 'Assign a Shopify product to a PowerQuest block with this System Finder role.';
                if (finderResultPrice) finderResultPrice.textContent = '—';
                if (finderResultLink) finderResultLink.setAttribute('href', '#aq-products');
                finderResult.classList.add('visible');
                return;
            }

            if (finderResultName) finderResultName.textContent = result.product.name;
            if (finderResultReason) finderResultReason.textContent = result.description;
            if (finderResultPrice) finderResultPrice.textContent = priceLabel(result.product);
            if (finderResultLink) finderResultLink.setAttribute('href', result.product.url || '#aq-products');

            finderResult.classList.add('visible');
            finderResult.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // =====================================================
        // EVENTS
        // =====================================================
        function setupEventListeners() {
            tierBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    tierBtns.forEach(function (b) { b.classList.remove('active'); });
                    btn.classList.add('active');
                    renderProducts(btn.getAttribute('data-aq-tier-btn'));
                });
            });

            root.addEventListener('click', function (e) {
                var detailsBtn = e.target.closest('[data-aq-show-details]');
                if (detailsBtn) {
                    showProductDetails(detailsBtn.getAttribute('data-aq-show-details'));
                }
            });

            finderGroups.forEach(function (group) {
                group.addEventListener('click', function (e) {
                    var option = e.target.closest('[data-aq-finder-value]');
                    if (!option) return;

                    group.querySelectorAll('[data-aq-finder-value]').forEach(function (opt) {
                        opt.classList.remove('selected');
                    });
                    option.classList.add('selected');
                    finderAnswers[group.getAttribute('data-aq-finder-group')] = option.getAttribute('data-aq-finder-value');
                });
            });

            if (finderSubmit) {
                finderSubmit.addEventListener('click', function () {
                    if (!finderAnswers.systemType || !finderAnswers.highPower || !finderAnswers.priority || !finderAnswers.space) {
                        window.alert('Please answer all questions to get your recommendation.');
                        return;
                    }
                    displayRecommendation(calculateRecommendation(finderAnswers));
                });
            }

            faqQuestions.forEach(function (question) {
                question.addEventListener('click', function () {
                    var isActive = question.classList.contains('active');
                    var answer = question.nextElementSibling;

                    faqQuestions.forEach(function (q) {
                        q.classList.remove('active');
                        if (q.nextElementSibling) q.nextElementSibling.style.maxHeight = '0';
                    });

                    if (!isActive && answer) {
                        question.classList.add('active');
                        answer.style.maxHeight = answer.scrollHeight + 'px';
                    }
                });
            });

            if (modalClose && modal) {
                modalClose.addEventListener('click', function () {
                    modal.classList.remove('active');
                });
                modal.addEventListener('click', function (e) {
                    if (e.target === modal) modal.classList.remove('active');
                });
            }

            root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
                anchor.addEventListener('click', function (e) {
                    var href = this.getAttribute('href');
                    if (href && href.length > 1) {
                        var target = root.querySelector(href) || document.querySelector(href);
                        if (target) {
                            e.preventDefault();
                            target.scrollIntoView({ behavior: 'smooth' });
                        }
                    }
                });
            });
        }

        function setupScrollAnimations() {
            if (!('IntersectionObserver' in window)) {
                root.querySelectorAll('.aq-fade-in').forEach(function (el) { el.classList.add('visible'); });
                return;
            }
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) entry.target.classList.add('visible');
                });
            }, { threshold: 0.1 });

            root.querySelectorAll('.aq-fade-in').forEach(function (el) { observer.observe(el); });
        }

        renderProducts('full_size');
        setupEventListeners();
        setupScrollAnimations();
    }

    function initAll() {
        document.querySelectorAll('.aq-pq').forEach(initAqPq);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector ? event.target.querySelector('.aq-pq') : null;
        if (section) initAqPq(section);
    });
})();
